import React, { useState } from 'react'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useStore } from '../../../Models/RootStore'
import makeStyles from '@mui/styles/makeStyles'
import { Title, Input, Button } from '../../../Components'
import { Colors } from '../../../Utils/theme'

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '44rem',
    [theme.breakpoints.down('xl')]: {
      maxWidth: '38rem'
    }
  },
  description: {
    marginBottom: '2rem'
  },
  button: {
    minHeight: '3.125rem',
    marginTop: '0.5rem',
    marginBottom: '1.75rem'
  },
  text: {
    margin: 0,
    fontFamily: 'Roboto',
    fontSize: '1rem',
    fontWeight: 300,
    color: Colors.black,
    textAlign: 'center'
  },
  link: {
    fontWeight: 500,
    textDecoration: 'underline',
    '&:hover': {
      textDecoration: 'none'
    }
  }
}))

const Login = (props) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const { sessionStore }: any = useStore()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const handleKeyPress = (evt: any) => {
    if (evt.key === 'Enter' && email && password) {
      login()
    }
  }
  const login = () => {
    sessionStore.login(email, password)
    // Clear password
    setPassword('')
  }

  return (
    <div className={classes.root}>
      <Title
        title={t('login')}
        description={t('login_description')}
        type='main'
        descriptionStyle={classes.description}
      />
      <Input label={t('email')} value={email} onChange={setEmail} autoFocus />
      <Input
        type='password'
        label={t('password')}
        value={password}
        onChange={setPassword}
        handleKeyPress={handleKeyPress}
      />
      <Button
        text={t('login_short')}
        onClick={login}
        buttonStyle={classes.button}
        fullWidth
      />
      <p className={classes.text}>
        {t('forgot_password')} {t('request_new')}
        <Link to='/reset-password' className={classes.link}>{t('from_here')}</Link>.
      </p>
    </div>
  )
}

export default observer(Login)
